/* eslint-disable */

import request from '@/utils/request'

export function getListTaxApi(query) {
  return request({
    url: '/config-service/v1/tax/list',
    method: 'get',
    params: query
  })
}

export function addTaxApi(query) {
  return request({
    url: '/config-service/v1/tax/add',
    method: 'post',
     data: query
  })
}

export function updateTaxApi(query) {
  return request({
    url: '/config-service/v1/tax/update',
    method: 'put',
     data: query
  })
}

export function deleteTaxApi(query) {
  return request({
    url: '/config-service/v1/tax/delete',
    method: 'delete',
    data: query
  })
}
